// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%2384888c%27%3E%3Cpath d=%27M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.launchpad_wrapper_main {
    padding: 50px 0;
    background-color: #181a20;
}

body.light_theme .launchpad_wrapper_main {
    background-color: #fff;
}

.launchpad_wrapper_main .container {
    max-width: 1240px;
}

.launchpad_cnt_block {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 18px;
}

.launchpad_right_cnt {
    max-width: 440px;
}

.launchpad_cnt_block h1 {
    color: #000;
    font-weight: 700;
}

.launchpad_cnt_block p {
    color: #84888C;
    font-size: 20px;
    font-weight: 500;
    margin: 18px 0px;
}

.launchpad_cnt_block ul {
    list-style: none;
    padding: 0;
    margin: 40px 0px 15px;
    display: flex;
    align-items: center;
    gap: 18px;
}

.launchpad_cnt_block ul li {
    display: flex;
    flex-direction: column;
    color: #000;
    font-size: 29px;
    line-height: 26px;
    font-weight: 600;
}

.launchpad_cnt_block ul li span {
    color: #84888C;
    font-size: 12px;
    font-weight: 400;
}

.about_Launchpad_btn button {
    min-height: 56px;
    border-radius: 50px;
    border: none;
    background-color: #F5F6F7;
}

.about_Launchpad_btn button.aboutbtn_launchpad {
    background-color: #303236;
    color: #fff;
    font-size: 17px;
    font-weight: 500;
    padding: 10px 30px;
}

.about_Launchpad_btn button.notification_btn {
    width: 56px;
}

/* Past Projects Section */
.launchpad_past_projects_sec {
    margin-top: 60px;
    padding-bottom: 0px;
}

.past_projects_title {
    font-size: 30px;
    font-weight: 600;
    color: #000;
    margin-bottom: 24px;
}

.launchpad_projects_tabs {
    display: flex;
    gap: 32px;
    margin-bottom: 30px;
}

.projects_tab {
    background: transparent;
    border: none;
    padding: 0 0 12px 0;
    font-size: 20px;
    font-weight: 600;
    color: #84888C;
    cursor: pointer;
    position: relative;
    transition: color 0.2s;
}

.projects_tab:hover {
    opacity: 0.8;
}

.projects_tab.active {
    color: #ffffff;
    font-weight: 600;
}

body.light_theme .projects_tab.active {
    color: #1E2329;
}

.projects_tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0px;
    margin: 0 auto;
    width: 50%;
    height: 3px;
    background-color: #D4B363;
}

.past_projects_list {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

@keyframes shimmer {
    0% {
        background-position: -1000px 0;
    }

    100% {
        background-position: 1000px 0;
    }
}

.skeleton_card [style*="background"] {
    animation: shimmer 2s infinite linear;
    background: #f6f7f8;
    background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
    background-repeat: no-repeat;
    background-size: 1000px 100%;
}

.project_card {
    background-color: #f9fafb0d;
    border-radius: 20px;
    padding: 24px;
    position: relative;
    margin-bottom: 24px;
}

body.light_theme .project_card {
    background-color: #F9FAFB;
}

.project_card_status {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #EBECED;
    color: #84888C;
    font-size: 13px;
    font-weight: 400;
    padding: 1px 12px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 12px;
}

.project_card_inner {
    display: flex;
    gap: 30px;
}

.about_Launchpad_btn button i {
    font-size: 20px;
}

.project_card_left {
    width: 320px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    cursor: pointer;
    transition: transform 0.2s;
}

.project_card_left:hover {
    transform: translateY(-2px);
}

.project_title_sec {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 30px;
}

.project_icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #1E2329;
}

.project_icon {
    width: 44px;
    height: 44px;
    border-radius: 50%;

}

.project_name_badge h3 {
    font-size: 23px;
    font-weight: 600;
    color: #fff;
    margin: 0;
}

body.light_theme .project_name_badge h3 {
    color: #000;
}

.initial_badge {
    display: inline-block;
    background-color: #89EFF6;
    color: #000000;
    font-size: 12px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 4px;
    margin-top: 4px;
}

.project_info_group {
    margin-bottom: 24px;
}

.project_info_group.mt-auto {
    margin-top: auto;
    margin-bottom: 0;
}

.info_label {
    color: #f0f0f0;
    font-size: 12px;
    margin-bottom: 1px;
}

body.light_theme .info_value p {
    color: #84888C;
}

.info_value p {
    color: #e8e8e8;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
}

body.light_theme .info_value p {
    color: #1E2329;
}

.info_value p:last-child {
    margin-bottom: 0;
}

.project_card_right {
    flex-grow: 1;
    display: flex;
    gap: 20px;
}

.pool_card {
    background-color: #ffffff12;
    border-radius: 16px;
    padding: 24px;
    color: #fff;
    flex: 1 1;
    max-width: calc(50% - 10px);
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
}

body.light_theme .pool_card {
    background-color: #FFFFFF;
    color: #1a1a1a;
}

.pool_card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
}

.pool_card:only-child {
    max-width: 50%;
}

.pool_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
}

.threshold_text {
    font-size: 12px;
    color: #c9c9c9;
    font-weight: 600;
}

body.light_theme .threshold_text {
    color: #1E2329;
}

.pool_icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
}

/* 
.pool_icon.usd1 {
    background: #F3BA2F;
}

.pool_icon.gusd {
    background: #E8A83E;
}

.pool_icon.usdt {
    background: #26A17B;
} */

.pool_title h4 {
    font-size: 19px;
    font-weight: 600;
    color: #fff;
    margin: 0;
}

body.light_theme .pool_title h4 {
    color: #000;
}

.pool_stats_row {
    display: flex;
    justify-content: space-between;
}

.stat_label {
    color: #84888C;
    font-size: 12px;
    margin-bottom: 1px;
}

.stat_value {
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}

body.light_theme .stat_value {
    color: #1E2329;
}

.stat_value span {
    font-size: 14px;
    font-weight: 600;
    margin-left: 4px;
}

.pool_summary {
    border-top: 1px solid #F2F3F4;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.summary_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.summary_label {
    color: #84888C;
    font-size: 12px;
    margin: 0;
}

.launchpad_wrapper_main .detail_header_row .action_btn {
    background-color: transparent;
    color: #efefef;
    padding: 0px;
    text-align: left;
    font-weight: 500;
    font-size: 14px;
}

.launchpad_wrapper_main .detail_header_row .action_btn img {
    filter: invert(1);
}

body.light_theme .launchpad_wrapper_main .detail_header_row .action_btn img {
    filter: invert(0);
}

body.light_theme .launchpad_wrapper_main .detail_header_row .action_btn {
    color: #141414;
}

body .detail_header_row span.text-dark {
    font-weight: 500;
    color: #fff !important;
}

body.light_theme .detail_header_row span.text-dark {
    color: #000 !important;
}

.summary_value {
    font-size: 12px;
    font-weight: 600;
    margin: 0;
}

.trade_btn {
    width: 100%;
    margin-top: 24px;
    background-color: #F5F6F7;
    color: #1E2329;
    font-size: 14px;
    font-weight: 500;
    border: none;
    border-radius: 8px;
    padding: 12px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.trade_btn:hover {
    background-color: #EAECEF;
}

.view_more_sec {
    text-align: center;
    margin-top: 40px;
}

.view_more_link {
    font-size: 16px;
    font-weight: 600;
    color: #1E2329;
    text-decoration: none;
    border-bottom: 1px solid #1E2329;
    padding-bottom: 2px;
}

.view_more_link:hover {
    color: #000;
    border-bottom-color: #000;
}

.no_projects_found {
    text-align: center;
    color: #84888C;
    padding: 80px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.launchpad_empty_img {
    width: 120px;
    height: 120px;
    margin-bottom: 16px;
    filter: invert(1);
    opacity: 0.9;
}

body.light_theme .launchpad_empty_img {
    filter: invert(0);
}

.detail_content_layout .pool_card {
    max-width: 100%;
}


/* Launchpad Detail Page Styles */
.detail_header_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0px 30px;
}

.breadcrumb {
    font-size: 16px;
    color: #84888C;
}

.breadcrumb .fw-bold {
    font-weight: 700;
    color: #1E2329;
}

.header_actions {
    display: flex;
    gap: 24px;
}

.action_btn {
    background: transparent;
    border: none;
    color: #1E2329;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
}

.action_btn i {
    font-size: 18px;
}

.detail_content_layout {
    display: flex;
    gap: 110px;
    align-items: flex-start;
}

.detail_left_col {
    flex: 1 1;
}

.detail_right_col {
    width: 440px;
    flex-shrink: 0;
}

.project_header_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.detail_project_name {
    font-size: 32px;
    font-weight: 600;
    color: #f6f6f6;
    margin: 0;
}

body.light_theme .detail_project_name {
    color: #000;
}

.status_ended_badge {
    background-color: #F5F6F7;
    color: #84888C;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 4px;
}

.trade_btn_dark {
    background-color: #303236;
    color: #fff;
    border: none;
    padding: 10px 24px;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 500;
    transition: 0.5s all;
}

.trade_btn_dark:hover {
    background-color: #545454;
}

.project_description p {
    color: #e3e3e3;
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 24px;
}

body.light_theme .project_description p {
    color: #1E2329;
}

.project_links {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 26px;
}

.pill_link {
    background-color: #F5F6F7;
    color: #070808;
    text-decoration: none;
    font-size: 12px;
    font-weight: 500;
    padding: 3px 12px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.5s;
}

.pill_link:hover {
    background-color: #d8d8d8;
}

.pill_link i {
    font-size: 16px;
}

.project_stats_row {
    display: flex;
    gap: 60px;
    margin-bottom: 40px;
}

.event_phases_sec {
    padding-top: 40px;
    width: 100%;
    display: block;
    color: #fff;
}

body.light_theme .event_phases_sec {
    color: #171717;
}

.stat_item {
    display: flex;
    flex-direction: column;
    gap: 0px;
}

.stat_item .label {
    color: #84888C;
    font-size: 11px;
    margin: 0px;
}

.stat_item .value {
    color: #e9e9e9;
    font-size: 15px;
    font-weight: 600;
}

body.light_theme .stat_item .value {
    color: #1E2329;
}

.event_phases_sec h3 {
    font-size: 22px;
    font-weight: 600;
    /* color: #000; */
    margin-bottom: 30px;
}

.timeline {
    display: flex;
    align-items: start;
    justify-content: space-between;
    position: relative;
}

.detail_content_layout .timeline_item {
    display: flex;
    flex-direction: column;
    align-items: normal;
    position: relative;
    z-index: 2;
    flex: 1 1;
}

.timeline_item .marker {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #444444;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 12px;
}


.timeline_item.completed .marker {
    background-color: #1E2329;
}

.detail_content_layout .timeline_line {
    height: 1px;
    background-color: #1e2329;
    flex: 2 1;
    margin: 0 10px;
    margin-bottom: 35px;
    top: 13px;
    left: 0%;
    right: 22%;
}

.timeline_line.completed {
    background-color: #1E2329;
}

.timeline_item .content h4 {
    font-size: 15px;
    font-weight: 500;
    color: #f4f4f4;
    margin: 6px 0 4px 0;
}

body.light_theme .timeline_item .content h4 {
    color: #1E2329;
}

.timeline_item .content p {
    font-size: 12px;
    color: #84888C;
    margin: 0;
}

/* Launchpad Details Table */
.launchpad_details_table_sec h3,
.project_details_tab_sec h3 {
    font-size: 22px;
    font-weight: 600;
    /* color: #000; */
    margin-bottom: 24px;
}

.details_table {
    border: 1px solid #eaecef54;
    border-radius: 16px;
    overflow: hidden;
}

body.light_theme .details_table {
    border: 1px solid #eaecef54;
}

.table_row {
    display: flex;
    border-bottom: 1px solid #eaecef54;
    background-color: #171a20;
}

body.light_theme .table_row {
    background-color: #fff;
    border-bottom: 1px solid #EAECEF;
}

.table_row:nth-child(odd) {
    background-color: #2a2c31;
}

body.light_theme .table_row:nth-child(odd) {
    background-color: #FAFAFA;
}

.table_row:last-child {
    border-bottom: none;
}



.launchpad_details_table_sec {
    margin-top: 80px;
    width: 100%;
    color: #fff;
    display: block;
}

body.light_theme .launchpad_details_table_sec {
    color: #171717;
}

.project_details_tab_sec {
    margin: 80px 0px 40px;
    color: #fff;
    width: 100%;
    display: block;
}

body.light_theme .project_details_tab_sec {
    color: #171717;
}

.table_col_left {
    flex: 1 1;
    padding: 20px 24px;
    color: #84888C;
    font-size: 14px;
}

.table_col_right {
    flex: 1 1;
    padding: 20px 24px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
}

body.light_theme .table_col_right {
    color: #010101;
}

/* Project Details Tabs */
.project_details_container {
    border: 1px solid #eaecef33;
    border-radius: 16px;
    display: flex;
    overflow: hidden;
    min-height: 400px;
}

body.light_theme .project_details_container {
    border: 1px solid #EAECEF;
}

.pill_link:hover {
    color: #000;
}

.sidebar_menu {
    width: 240px;
    padding: 24px;
    flex-shrink: 0;
}

.menu_item {
    padding: 12px 24px;
    color: #84888C;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    position: relative;
    transition: all 0.2s;
}

.menu_item:hover {
    color: #1E2329;
    background-color: #F5F6F7;
}

.menu_item.active {
    color: #1E2329;
    background-color: #FAFAFA;
}

.project_details_container h4 {
    font-size: 15px;
    color: #fff;
}

body.light_theme .project_details_container h4 {
    color: #232323;
}

.menu_item.active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0px;
    bottom: 0px;
    width: 3px;
    background-color: #737a8b;
}

body.light_theme .menu_item.active::before {
    background-color: #1E2329;
}

.highlight_info p {
    color: #fff;
}

body.light_theme .highlight_info p {
    color: #121212;
}

.content_area {
    padding: 32px;
    flex-grow: 1;
    background-color: #2a2c31;
}

body.light_theme .content_area {
    background-color: #fff;
}

.founder_img_placeholder {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #EAECEF;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 60%;
    background-position: center;
    background-repeat: no-repeat;
}

.founder_info.mb-4 .content_text {
    font-size: 13px;
    line-height: 1.6;
    color: #e9e9e9;
}

body.light_theme .founder_info.mb-4 .content_text {
    color: #1E2329;
}

.detail_pool_card {
    border: 1px solid #EAECEF;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
}


/* About Launchpad Modal */
.launchpad_modal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.30);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999999;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
}

body.light_theme .launchpad_modal_overlay {
    background-color: rgb(255 255 255 / 20%);
}

.launchpad_modal_content {
    background-color: rgb(24 26 32 / 70%);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 12px;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    width: 90%;
    max-width: 800px;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.5);
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
}

body.light_theme .launchpad_modal_content {
    background-color: rgb(255 255 255 / 20%);
    border: none;
    box-shadow: 0px 2px 20px #0000004a;
}

.launchpad_modal_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 32px 40px 20px;
    margin: 0;
}

.launchpad_modal_header h2 {
    font-size: 22px;
    font-weight: 700;
    color: #ffffff;
    margin: 0;
}

body.light_theme .launchpad_modal_header h2 {
    color: #1E2329;
}

.close_modal_btn {
    background: none;
    border: none;
    font-size: 24px;
    color: #84888C;
    cursor: pointer;
    padding: 0;
    transition: color 0.2s ease;
}

.close_modal_btn:hover {
    color: #ffffff;
}

body.light_theme .close_modal_btn:hover {
    color: #000000;
}

.launchpad_modal_tabs {
    display: flex;
    gap: 32px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 32px;
}

body.light_theme .launchpad_modal_tabs {
    border-bottom: 1px solid #EAECEF;
}

.launchpad_modal_tabs .tab_btn {
    background: none;
    border: none;
    padding: 0 0 12px 0;
    font-size: 16px;
    font-weight: 600;
    color: #84888C;
    cursor: pointer;
    position: relative;
}

.launchpad_modal_tabs .tab_btn.active {
    color: #ffffff;
}

body.light_theme .launchpad_modal_tabs .tab_btn.active {
    color: #1E2329;
}

.launchpad_modal_tabs .tab_btn.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #D1AA67;
    border-radius: 2px 2px 0 0;
}

body.light_theme .launchpad_modal_tabs .tab_btn.active::after {
    background-color: #1E2329;
}

.launchpad_modal_body {
    padding: 0 40px 32px;
    overflow-y: auto;
    flex-grow: 1;
}

.faq_item {
    margin-bottom: 32px;
}

.faq_item h5 {
    font-size: 16px;
    font-weight: 700;
    color: #cacaca;
    margin-bottom: 12px;
}

body.light_theme .faq_item h5 {
    color: #1E2329;
}

.faq_item p {
    font-size: 14px;
    color: #e3e3e3;
    line-height: 1.6;
    margin: 0;
}

body.light_theme .faq_item p {
    color: #1E2329;
}

body.light_theme section.faq_cards h1.text-center img {
    filter: invert(1);
}

.faq_item a {
    color: #D1AA67;
    text-decoration: underline;
    font-weight: 600;
}

body.light_theme .faq_item a {
    color: #1E2329;
}

.launchpad_modal_overlay .close_modal_btn {
    color: #84888C;
}

body.light_theme .launchpad_modal_overlay .close_modal_btn {
    color: #202020;
}

@media (max-width: 1024px) {
    .project_card_inner {
        flex-direction: column;
    }

    .project_card_left {
        width: 100%;
        margin-bottom: 20px;
    }

    .project_card_right {
        flex-direction: column;
    }

    .pool_card,
    .pool_card:only-child {
        max-width: 100%;
    }

    .detail_content_layout {
        gap: 40px;
    }
}

@media (max-width: 991px) {

    .launchpad_cnt_block p {
        font-size: 16px;
        margin: 14px 0px;
    }

    .launchpad_cnt_block ul li {
        font-size: 22px;
        line-height: 24px;
    }

    .launchpad_right_cnt {
        max-width: 320px;
    }

    .past_projects_title {
        font-size: 24px;
        margin-bottom: 20px;
    }

    .about_Launchpad_btn button.aboutbtn_launchpad {
        font-size: 14px;
        padding: 6px 30px;
    }

    .about_Launchpad_btn button.notification_btn {
        width: 42px;
    }

    .about_Launchpad_btn button {
        min-height: 42px;
    }

    .detail_right_col {
        width: auto;
        margin-top: 40px;
    }

    .detail_left_col {
        width: 50%;
    }

    .detail_header_row {
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
    }

    .detail_content_layout .timeline_line {
        right: -2%;
    }

    .sidebar_menu {
        padding: 14px;
        width: 45%;
    }

    .content_area {
        padding: 18px;
    }

    .menu_item {
        padding: 10px 16px;
    }
}

@media (max-width: 767px) {

    .detail_content_layout {
        flex-direction: column;
    }

    .launchpad_modal_content {
        border-radius: 12px 12px 0px 0px;
        width: 100%;
        max-width: 100%;
    }

    .launchpad_modal_header {
        padding: 15px 20px 15px;
    }

    .launchpad_modal_body {
        padding: 0 20px 20px;
    }

    .launchpad_modal_header h2 {
        font-size: 18px;
    }

    .detail_left_col {
        width: 100%;
    }

    .detail_project_name {
        font-size: 24px;
    }

    .project_stats_row {
        gap: 30px;
        margin-bottom: 20px;
    }

    .project_card_inner .project_card_left {
        margin-bottom: 0px;
    }

    .event_phases_sec {
        padding-top: 20px;
    }

    .event_phases_sec h3 {
        font-size: 20px;
        margin-bottom: 20px;
    }

    .detail_content_layout .timeline_item {
        width: auto;
        min-width: auto;
    }

    .detail_content_layout .timeline_line {
        right: 21%;
    }

    .launchpad_details_table_sec {
        margin-top: 40px;
    }

    .project_details_tab_sec {
        margin: 40px 0px 0px;
    }

    .detail_right_col {
        width: 100%;
        margin-top: 0px;
    }

    .launchpad_modal_overlay {
        align-items: end;
    }

}

@media (max-width: 660px) {

    .launchpad_cnt_block {
        text-align: center;
        flex-direction: column;
    }

    .launchpad_details_table_sec h3,
    .project_details_tab_sec h3 {
        font-size: 20px;
    }

    .pool_card {
        padding: 20px;
    }

    .detail_content_layout .timeline_item {
        flex-direction: row;
        gap: 12px;
    }

    .detail_content_layout .timeline_item h4 {
        margin-top: 0px;
    }

    .launchpad_cnt_block ul {
        margin: 20px 0px 15px;
        justify-content: center;
    }

    .launchpad_cnt_block ul li {
        font-size: 19px;
        line-height: 20px;
    }

    .about_Launchpad_btn {
        justify-content: center;
    }

    .about_Launchpad_btn button.notification_btn {
        padding: 0px;
    }

    .past_projects_title {
        font-size: 22px;
    }

    .launchpad_past_projects_sec {
        padding-bottom: 30px;
        margin-top: 30px !important;
    }

    .pool_title h4 {
        font-size: 15px;
    }

    .project_name_badge h3 {
        font-size: 16px;
    }

    .project_icon {
        width: 32px;
        height: 32px;
    }

    .launchpad_wrapper_main {
        padding: 40px 0;
    }

    .timeline {
        flex-direction: column;
        align-items: flex-start;
        gap: 18px;
    }

    .timeline_item {
        flex-direction: row;
        align-items: center;
        gap: 20px;
    }

    .timeline_item .marker {
        margin-bottom: 0;
    }

    .timeline_line {
        display: none;
    }

    .project_details_container {
        flex-direction: column;
        min-height: 250px;
    }

    .detail_header_row {
        margin: 0px 0px 20px;
    }

    .breadcrumb {
        margin-bottom: 0px;
        font-size: 14px;
    }

    .sidebar_menu {
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #EAECEF;
        display: flex;
        overflow-x: auto;
        padding: 0;
    }

    .menu_item {
        white-space: nowrap;
        padding: 16px;
    }

    .menu_item.active::before {
        left: 16px;
        right: 16px;
        bottom: 0;
        top: auto;
        height: 3px;
        width: auto;
        border-radius: 4px 4px 0 0;
    }

    .table_row {
        flex-direction: column;
    }

    .table_col_left {
        padding: 16px 20px 2px;
        border-bottom: none;
    }

    .table_col_right {
        padding: 4px 20px 16px;
    }

    body .header_actions {
        gap: 12px;
    }

    .launchpad_wrapper_main .detail_header_row .action_btn {
        font-size: 12px;
    }

    .trade_btn_dark {
        padding: 8px 24px;
        font-size: 12px;
    }

    .detail_content_layout {
        gap: 20px;
    }

    .projects_tab {
        font-size: 16px;
    }

    .launchpad_projects_tabs {
        gap: 20px;
        margin-bottom: 22px;
    }

}

/* Trade Form Specific Styles */
.launchpad-trade-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.launchpad-trade-row.mt-16 {
    margin-bottom: 0;
    margin-top: 16px;
}

.launchpad-trade-row.mb-12 {
    margin-bottom: 12px;
}

.launchpad-trade-label {
    display: block;
    margin-bottom: 8px;
    color: #848e9c;
    font-size: 14px;
}

.launchpad-trade-input {
    width: 100%;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    outline: none;
    font-size: 15px;
    background-color: rgba(255, 255, 255, 0.05);
    color: #fff;
}

.launchpad-trade-input::placeholder {
    color: #848e9c;
}

body.light_theme .launchpad-trade-input {
    border: 1px solid #EAECEF;
    background-color: #fff;
    color: #1e2329;
}

.launchpad-trade-error {
    color: #dc3545;
    font-size: 13px;
    margin: 8px 0 0;
}

.launchpad-trade-btn {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Launchpad/launchpad.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA,0BAA0B;AAC1B;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,UAAU;IACV,cAAc;IACd,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,+FAA+F;IAC/F,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,SAAO;IACP,2BAA2B;IAC3B,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;;;;;;;;;;GAWG;;AAEH;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;;AAGA,iCAAiC;AACjC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,SAAS;IACT,cAAc;IACd,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA,4BAA4B;AAC5B;;IAEI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;;;AAIA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yDAAoQ;IACpQ,oBAAoB;IACpB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,0CAA0C;AAC9C;;;AAGA,0BAA0B;AAC1B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,kCAAkC;IAClC,0BAA0B;IAC1B,UAAU;IACV,gBAAgB;IAChB,2CAA2C;IAC3C,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iDAAiD;IACjD,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;;IAEI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,gCAAgC;QAChC,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;AAEJ;;AAEA;;IAEI;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;QACrB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;QACpB,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,gCAAgC;QAChC,aAAa;QACb,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,SAAS;QACT,SAAS;QACT,WAAW;QACX,WAAW;QACX,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,mBAAmB;IACvB;;AAEJ;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,eAAe;IACf,2CAA2C;IAC3C,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".launchpad_wrapper_main {\n    padding: 50px 0;\n    background-color: #181a20;\n}\n\nbody.light_theme .launchpad_wrapper_main {\n    background-color: #fff;\n}\n\n.launchpad_wrapper_main .container {\n    max-width: 1240px;\n}\n\n.launchpad_cnt_block {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 18px;\n}\n\n.launchpad_right_cnt {\n    max-width: 440px;\n}\n\n.launchpad_cnt_block h1 {\n    color: #000;\n    font-weight: 700;\n}\n\n.launchpad_cnt_block p {\n    color: #84888C;\n    font-size: 20px;\n    font-weight: 500;\n    margin: 18px 0px;\n}\n\n.launchpad_cnt_block ul {\n    list-style: none;\n    padding: 0;\n    margin: 40px 0px 15px;\n    display: flex;\n    align-items: center;\n    gap: 18px;\n}\n\n.launchpad_cnt_block ul li {\n    display: flex;\n    flex-direction: column;\n    color: #000;\n    font-size: 29px;\n    line-height: 26px;\n    font-weight: 600;\n}\n\n.launchpad_cnt_block ul li span {\n    color: #84888C;\n    font-size: 12px;\n    font-weight: 400;\n}\n\n.about_Launchpad_btn button {\n    min-height: 56px;\n    border-radius: 50px;\n    border: none;\n    background-color: #F5F6F7;\n}\n\n.about_Launchpad_btn button.aboutbtn_launchpad {\n    background-color: #303236;\n    color: #fff;\n    font-size: 17px;\n    font-weight: 500;\n    padding: 10px 30px;\n}\n\n.about_Launchpad_btn button.notification_btn {\n    width: 56px;\n}\n\n/* Past Projects Section */\n.launchpad_past_projects_sec {\n    margin-top: 60px;\n    padding-bottom: 0px;\n}\n\n.past_projects_title {\n    font-size: 30px;\n    font-weight: 600;\n    color: #000;\n    margin-bottom: 24px;\n}\n\n.launchpad_projects_tabs {\n    display: flex;\n    gap: 32px;\n    margin-bottom: 30px;\n}\n\n.projects_tab {\n    background: transparent;\n    border: none;\n    padding: 0 0 12px 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: #84888C;\n    cursor: pointer;\n    position: relative;\n    transition: color 0.2s;\n}\n\n.projects_tab:hover {\n    opacity: 0.8;\n}\n\n.projects_tab.active {\n    color: #ffffff;\n    font-weight: 600;\n}\n\nbody.light_theme .projects_tab.active {\n    color: #1E2329;\n}\n\n.projects_tab.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    right: 0px;\n    margin: 0 auto;\n    width: 50%;\n    height: 3px;\n    background-color: #D4B363;\n}\n\n.past_projects_list {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n@keyframes shimmer {\n    0% {\n        background-position: -1000px 0;\n    }\n\n    100% {\n        background-position: 1000px 0;\n    }\n}\n\n.skeleton_card [style*=\"background\"] {\n    animation: shimmer 2s infinite linear;\n    background: #f6f7f8;\n    background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);\n    background-repeat: no-repeat;\n    background-size: 1000px 100%;\n}\n\n.project_card {\n    background-color: #f9fafb0d;\n    border-radius: 20px;\n    padding: 24px;\n    position: relative;\n    margin-bottom: 24px;\n}\n\nbody.light_theme .project_card {\n    background-color: #F9FAFB;\n}\n\n.project_card_status {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: #EBECED;\n    color: #84888C;\n    font-size: 13px;\n    font-weight: 400;\n    padding: 1px 12px;\n    border-top-right-radius: 20px;\n    border-bottom-left-radius: 12px;\n}\n\n.project_card_inner {\n    display: flex;\n    gap: 30px;\n}\n\n.about_Launchpad_btn button i {\n    font-size: 20px;\n}\n\n.project_card_left {\n    width: 320px;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    padding-top: 10px;\n    cursor: pointer;\n    transition: transform 0.2s;\n}\n\n.project_card_left:hover {\n    transform: translateY(-2px);\n}\n\n.project_title_sec {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 30px;\n}\n\n.project_icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background-color: #1E2329;\n}\n\n.project_icon {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n\n}\n\n.project_name_badge h3 {\n    font-size: 23px;\n    font-weight: 600;\n    color: #fff;\n    margin: 0;\n}\n\nbody.light_theme .project_name_badge h3 {\n    color: #000;\n}\n\n.initial_badge {\n    display: inline-block;\n    background-color: #89EFF6;\n    color: #000000;\n    font-size: 12px;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: 4px;\n    margin-top: 4px;\n}\n\n.project_info_group {\n    margin-bottom: 24px;\n}\n\n.project_info_group.mt-auto {\n    margin-top: auto;\n    margin-bottom: 0;\n}\n\n.info_label {\n    color: #f0f0f0;\n    font-size: 12px;\n    margin-bottom: 1px;\n}\n\nbody.light_theme .info_value p {\n    color: #84888C;\n}\n\n.info_value p {\n    color: #e8e8e8;\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 4px;\n}\n\nbody.light_theme .info_value p {\n    color: #1E2329;\n}\n\n.info_value p:last-child {\n    margin-bottom: 0;\n}\n\n.project_card_right {\n    flex-grow: 1;\n    display: flex;\n    gap: 20px;\n}\n\n.pool_card {\n    background-color: #ffffff12;\n    border-radius: 16px;\n    padding: 24px;\n    color: #fff;\n    flex: 1;\n    max-width: calc(50% - 10px);\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s;\n}\n\nbody.light_theme .pool_card {\n    background-color: #FFFFFF;\n    color: #1a1a1a;\n}\n\n.pool_card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);\n}\n\n.pool_card:only-child {\n    max-width: 50%;\n}\n\n.pool_title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 24px;\n}\n\n.threshold_text {\n    font-size: 12px;\n    color: #c9c9c9;\n    font-weight: 600;\n}\n\nbody.light_theme .threshold_text {\n    color: #1E2329;\n}\n\n.pool_icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n}\n\n/* \n.pool_icon.usd1 {\n    background: #F3BA2F;\n}\n\n.pool_icon.gusd {\n    background: #E8A83E;\n}\n\n.pool_icon.usdt {\n    background: #26A17B;\n} */\n\n.pool_title h4 {\n    font-size: 19px;\n    font-weight: 600;\n    color: #fff;\n    margin: 0;\n}\n\nbody.light_theme .pool_title h4 {\n    color: #000;\n}\n\n.pool_stats_row {\n    display: flex;\n    justify-content: space-between;\n}\n\n.stat_label {\n    color: #84888C;\n    font-size: 12px;\n    margin-bottom: 1px;\n}\n\n.stat_value {\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0;\n}\n\nbody.light_theme .stat_value {\n    color: #1E2329;\n}\n\n.stat_value span {\n    font-size: 14px;\n    font-weight: 600;\n    margin-left: 4px;\n}\n\n.pool_summary {\n    border-top: 1px solid #F2F3F4;\n    padding-top: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.summary_row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.summary_label {\n    color: #84888C;\n    font-size: 12px;\n    margin: 0;\n}\n\n.launchpad_wrapper_main .detail_header_row .action_btn {\n    background-color: transparent;\n    color: #efefef;\n    padding: 0px;\n    text-align: left;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.launchpad_wrapper_main .detail_header_row .action_btn img {\n    filter: invert(1);\n}\n\nbody.light_theme .launchpad_wrapper_main .detail_header_row .action_btn img {\n    filter: invert(0);\n}\n\nbody.light_theme .launchpad_wrapper_main .detail_header_row .action_btn {\n    color: #141414;\n}\n\nbody .detail_header_row span.text-dark {\n    font-weight: 500;\n    color: #fff !important;\n}\n\nbody.light_theme .detail_header_row span.text-dark {\n    color: #000 !important;\n}\n\n.summary_value {\n    font-size: 12px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.trade_btn {\n    width: 100%;\n    margin-top: 24px;\n    background-color: #F5F6F7;\n    color: #1E2329;\n    font-size: 14px;\n    font-weight: 500;\n    border: none;\n    border-radius: 8px;\n    padding: 12px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.trade_btn:hover {\n    background-color: #EAECEF;\n}\n\n.view_more_sec {\n    text-align: center;\n    margin-top: 40px;\n}\n\n.view_more_link {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1E2329;\n    text-decoration: none;\n    border-bottom: 1px solid #1E2329;\n    padding-bottom: 2px;\n}\n\n.view_more_link:hover {\n    color: #000;\n    border-bottom-color: #000;\n}\n\n.no_projects_found {\n    text-align: center;\n    color: #84888C;\n    padding: 80px 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.launchpad_empty_img {\n    width: 120px;\n    height: 120px;\n    margin-bottom: 16px;\n    filter: invert(1);\n    opacity: 0.9;\n}\n\nbody.light_theme .launchpad_empty_img {\n    filter: invert(0);\n}\n\n.detail_content_layout .pool_card {\n    max-width: 100%;\n}\n\n\n/* Launchpad Detail Page Styles */\n.detail_header_row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 20px 0px 30px;\n}\n\n.breadcrumb {\n    font-size: 16px;\n    color: #84888C;\n}\n\n.breadcrumb .fw-bold {\n    font-weight: 700;\n    color: #1E2329;\n}\n\n.header_actions {\n    display: flex;\n    gap: 24px;\n}\n\n.action_btn {\n    background: transparent;\n    border: none;\n    color: #1E2329;\n    font-size: 14px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n}\n\n.action_btn i {\n    font-size: 18px;\n}\n\n.detail_content_layout {\n    display: flex;\n    gap: 110px;\n    align-items: flex-start;\n}\n\n.detail_left_col {\n    flex: 1;\n}\n\n.detail_right_col {\n    width: 440px;\n    flex-shrink: 0;\n}\n\n.project_header_info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.detail_project_name {\n    font-size: 32px;\n    font-weight: 600;\n    color: #f6f6f6;\n    margin: 0;\n}\n\nbody.light_theme .detail_project_name {\n    color: #000;\n}\n\n.status_ended_badge {\n    background-color: #F5F6F7;\n    color: #84888C;\n    font-size: 12px;\n    font-weight: 600;\n    padding: 4px 8px;\n    border-radius: 4px;\n}\n\n.trade_btn_dark {\n    background-color: #303236;\n    color: #fff;\n    border: none;\n    padding: 10px 24px;\n    border-radius: 50px;\n    font-size: 14px;\n    font-weight: 500;\n    transition: 0.5s all;\n}\n\n.trade_btn_dark:hover {\n    background-color: #545454;\n}\n\n.project_description p {\n    color: #e3e3e3;\n    font-size: 14px;\n    line-height: 1.6;\n    margin-bottom: 24px;\n}\n\nbody.light_theme .project_description p {\n    color: #1E2329;\n}\n\n.project_links {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 26px;\n}\n\n.pill_link {\n    background-color: #F5F6F7;\n    color: #070808;\n    text-decoration: none;\n    font-size: 12px;\n    font-weight: 500;\n    padding: 3px 12px;\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    transition: all 0.5s;\n}\n\n.pill_link:hover {\n    background-color: #d8d8d8;\n}\n\n.pill_link i {\n    font-size: 16px;\n}\n\n.project_stats_row {\n    display: flex;\n    gap: 60px;\n    margin-bottom: 40px;\n}\n\n.event_phases_sec {\n    padding-top: 40px;\n    width: 100%;\n    display: block;\n    color: #fff;\n}\n\nbody.light_theme .event_phases_sec {\n    color: #171717;\n}\n\n.stat_item {\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n}\n\n.stat_item .label {\n    color: #84888C;\n    font-size: 11px;\n    margin: 0px;\n}\n\n.stat_item .value {\n    color: #e9e9e9;\n    font-size: 15px;\n    font-weight: 600;\n}\n\nbody.light_theme .stat_item .value {\n    color: #1E2329;\n}\n\n.event_phases_sec h3 {\n    font-size: 22px;\n    font-weight: 600;\n    /* color: #000; */\n    margin-bottom: 30px;\n}\n\n.timeline {\n    display: flex;\n    align-items: start;\n    justify-content: space-between;\n    position: relative;\n}\n\n.detail_content_layout .timeline_item {\n    display: flex;\n    flex-direction: column;\n    align-items: normal;\n    position: relative;\n    z-index: 2;\n    flex: 1;\n}\n\n.timeline_item .marker {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background-color: #444444;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    font-weight: 600;\n    margin-bottom: 12px;\n}\n\n\n.timeline_item.completed .marker {\n    background-color: #1E2329;\n}\n\n.detail_content_layout .timeline_line {\n    height: 1px;\n    background-color: #1e2329;\n    flex: 2 1;\n    margin: 0 10px;\n    margin-bottom: 35px;\n    top: 13px;\n    left: 0%;\n    right: 22%;\n}\n\n.timeline_line.completed {\n    background-color: #1E2329;\n}\n\n.timeline_item .content h4 {\n    font-size: 15px;\n    font-weight: 500;\n    color: #f4f4f4;\n    margin: 6px 0 4px 0;\n}\n\nbody.light_theme .timeline_item .content h4 {\n    color: #1E2329;\n}\n\n.timeline_item .content p {\n    font-size: 12px;\n    color: #84888C;\n    margin: 0;\n}\n\n/* Launchpad Details Table */\n.launchpad_details_table_sec h3,\n.project_details_tab_sec h3 {\n    font-size: 22px;\n    font-weight: 600;\n    /* color: #000; */\n    margin-bottom: 24px;\n}\n\n.details_table {\n    border: 1px solid #eaecef54;\n    border-radius: 16px;\n    overflow: hidden;\n}\n\nbody.light_theme .details_table {\n    border: 1px solid #eaecef54;\n}\n\n.table_row {\n    display: flex;\n    border-bottom: 1px solid #eaecef54;\n    background-color: #171a20;\n}\n\nbody.light_theme .table_row {\n    background-color: #fff;\n    border-bottom: 1px solid #EAECEF;\n}\n\n.table_row:nth-child(odd) {\n    background-color: #2a2c31;\n}\n\nbody.light_theme .table_row:nth-child(odd) {\n    background-color: #FAFAFA;\n}\n\n.table_row:last-child {\n    border-bottom: none;\n}\n\n\n\n.launchpad_details_table_sec {\n    margin-top: 80px;\n    width: 100%;\n    color: #fff;\n    display: block;\n}\n\nbody.light_theme .launchpad_details_table_sec {\n    color: #171717;\n}\n\n.project_details_tab_sec {\n    margin: 80px 0px 40px;\n    color: #fff;\n    width: 100%;\n    display: block;\n}\n\nbody.light_theme .project_details_tab_sec {\n    color: #171717;\n}\n\n.table_col_left {\n    flex: 1;\n    padding: 20px 24px;\n    color: #84888C;\n    font-size: 14px;\n}\n\n.table_col_right {\n    flex: 1 1;\n    padding: 20px 24px;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 500;\n}\n\nbody.light_theme .table_col_right {\n    color: #010101;\n}\n\n/* Project Details Tabs */\n.project_details_container {\n    border: 1px solid #eaecef33;\n    border-radius: 16px;\n    display: flex;\n    overflow: hidden;\n    min-height: 400px;\n}\n\nbody.light_theme .project_details_container {\n    border: 1px solid #EAECEF;\n}\n\n.pill_link:hover {\n    color: #000;\n}\n\n.sidebar_menu {\n    width: 240px;\n    padding: 24px;\n    flex-shrink: 0;\n}\n\n.menu_item {\n    padding: 12px 24px;\n    color: #84888C;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    position: relative;\n    transition: all 0.2s;\n}\n\n.menu_item:hover {\n    color: #1E2329;\n    background-color: #F5F6F7;\n}\n\n.menu_item.active {\n    color: #1E2329;\n    background-color: #FAFAFA;\n}\n\n.project_details_container h4 {\n    font-size: 15px;\n    color: #fff;\n}\n\nbody.light_theme .project_details_container h4 {\n    color: #232323;\n}\n\n.menu_item.active::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0px;\n    bottom: 0px;\n    width: 3px;\n    background-color: #737a8b;\n}\n\nbody.light_theme .menu_item.active::before {\n    background-color: #1E2329;\n}\n\n.highlight_info p {\n    color: #fff;\n}\n\nbody.light_theme .highlight_info p {\n    color: #121212;\n}\n\n.content_area {\n    padding: 32px;\n    flex-grow: 1;\n    background-color: #2a2c31;\n}\n\nbody.light_theme .content_area {\n    background-color: #fff;\n}\n\n.founder_img_placeholder {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background-color: #EAECEF;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2384888c'%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/svg%3E\");\n    background-size: 60%;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.founder_info.mb-4 .content_text {\n    font-size: 13px;\n    line-height: 1.6;\n    color: #e9e9e9;\n}\n\nbody.light_theme .founder_info.mb-4 .content_text {\n    color: #1E2329;\n}\n\n.detail_pool_card {\n    border: 1px solid #EAECEF;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);\n}\n\n\n/* About Launchpad Modal */\n.launchpad_modal_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.30);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999999;\n    backdrop-filter: blur(5px);\n}\n\nbody.light_theme .launchpad_modal_overlay {\n    background-color: rgb(255 255 255 / 20%);\n}\n\n.launchpad_modal_content {\n    background-color: rgb(24 26 32 / 70%);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 12px;\n    -webkit-backdrop-filter: blur(5px);\n    backdrop-filter: blur(5px);\n    width: 90%;\n    max-width: 800px;\n    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.5);\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    position: relative;\n}\n\nbody.light_theme .launchpad_modal_content {\n    background-color: rgb(255 255 255 / 20%);\n    border: none;\n    box-shadow: 0px 2px 20px #0000004a;\n}\n\n.launchpad_modal_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 32px 40px 20px;\n    margin: 0;\n}\n\n.launchpad_modal_header h2 {\n    font-size: 22px;\n    font-weight: 700;\n    color: #ffffff;\n    margin: 0;\n}\n\nbody.light_theme .launchpad_modal_header h2 {\n    color: #1E2329;\n}\n\n.close_modal_btn {\n    background: none;\n    border: none;\n    font-size: 24px;\n    color: #84888C;\n    cursor: pointer;\n    padding: 0;\n    transition: color 0.2s ease;\n}\n\n.close_modal_btn:hover {\n    color: #ffffff;\n}\n\nbody.light_theme .close_modal_btn:hover {\n    color: #000000;\n}\n\n.launchpad_modal_tabs {\n    display: flex;\n    gap: 32px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    margin-bottom: 32px;\n}\n\nbody.light_theme .launchpad_modal_tabs {\n    border-bottom: 1px solid #EAECEF;\n}\n\n.launchpad_modal_tabs .tab_btn {\n    background: none;\n    border: none;\n    padding: 0 0 12px 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #84888C;\n    cursor: pointer;\n    position: relative;\n}\n\n.launchpad_modal_tabs .tab_btn.active {\n    color: #ffffff;\n}\n\nbody.light_theme .launchpad_modal_tabs .tab_btn.active {\n    color: #1E2329;\n}\n\n.launchpad_modal_tabs .tab_btn.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background-color: #D1AA67;\n    border-radius: 2px 2px 0 0;\n}\n\nbody.light_theme .launchpad_modal_tabs .tab_btn.active::after {\n    background-color: #1E2329;\n}\n\n.launchpad_modal_body {\n    padding: 0 40px 32px;\n    overflow-y: auto;\n    flex-grow: 1;\n}\n\n.faq_item {\n    margin-bottom: 32px;\n}\n\n.faq_item h5 {\n    font-size: 16px;\n    font-weight: 700;\n    color: #cacaca;\n    margin-bottom: 12px;\n}\n\nbody.light_theme .faq_item h5 {\n    color: #1E2329;\n}\n\n.faq_item p {\n    font-size: 14px;\n    color: #e3e3e3;\n    line-height: 1.6;\n    margin: 0;\n}\n\nbody.light_theme .faq_item p {\n    color: #1E2329;\n}\n\nbody.light_theme section.faq_cards h1.text-center img {\n    filter: invert(1);\n}\n\n.faq_item a {\n    color: #D1AA67;\n    text-decoration: underline;\n    font-weight: 600;\n}\n\nbody.light_theme .faq_item a {\n    color: #1E2329;\n}\n\n.launchpad_modal_overlay .close_modal_btn {\n    color: #84888C;\n}\n\nbody.light_theme .launchpad_modal_overlay .close_modal_btn {\n    color: #202020;\n}\n\n@media (max-width: 1024px) {\n    .project_card_inner {\n        flex-direction: column;\n    }\n\n    .project_card_left {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .project_card_right {\n        flex-direction: column;\n    }\n\n    .pool_card,\n    .pool_card:only-child {\n        max-width: 100%;\n    }\n\n    .detail_content_layout {\n        gap: 40px;\n    }\n}\n\n@media (max-width: 991px) {\n\n    .launchpad_cnt_block p {\n        font-size: 16px;\n        margin: 14px 0px;\n    }\n\n    .launchpad_cnt_block ul li {\n        font-size: 22px;\n        line-height: 24px;\n    }\n\n    .launchpad_right_cnt {\n        max-width: 320px;\n    }\n\n    .past_projects_title {\n        font-size: 24px;\n        margin-bottom: 20px;\n    }\n\n    .about_Launchpad_btn button.aboutbtn_launchpad {\n        font-size: 14px;\n        padding: 6px 30px;\n    }\n\n    .about_Launchpad_btn button.notification_btn {\n        width: 42px;\n    }\n\n    .about_Launchpad_btn button {\n        min-height: 42px;\n    }\n\n    .detail_right_col {\n        width: auto;\n        margin-top: 40px;\n    }\n\n    .detail_left_col {\n        width: 50%;\n    }\n\n    .detail_header_row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 20px;\n    }\n\n    .detail_content_layout .timeline_line {\n        right: -2%;\n    }\n\n    .sidebar_menu {\n        padding: 14px;\n        width: 45%;\n    }\n\n    .content_area {\n        padding: 18px;\n    }\n\n    .menu_item {\n        padding: 10px 16px;\n    }\n}\n\n@media (max-width: 767px) {\n\n    .detail_content_layout {\n        flex-direction: column;\n    }\n\n    .launchpad_modal_content {\n        border-radius: 12px 12px 0px 0px;\n        width: 100%;\n        max-width: 100%;\n    }\n\n    .launchpad_modal_header {\n        padding: 15px 20px 15px;\n    }\n\n    .launchpad_modal_body {\n        padding: 0 20px 20px;\n    }\n\n    .launchpad_modal_header h2 {\n        font-size: 18px;\n    }\n\n    .detail_left_col {\n        width: 100%;\n    }\n\n    .detail_project_name {\n        font-size: 24px;\n    }\n\n    .project_stats_row {\n        gap: 30px;\n        margin-bottom: 20px;\n    }\n\n    .project_card_inner .project_card_left {\n        margin-bottom: 0px;\n    }\n\n    .event_phases_sec {\n        padding-top: 20px;\n    }\n\n    .event_phases_sec h3 {\n        font-size: 20px;\n        margin-bottom: 20px;\n    }\n\n    .detail_content_layout .timeline_item {\n        width: auto;\n        min-width: auto;\n    }\n\n    .detail_content_layout .timeline_line {\n        right: 21%;\n    }\n\n    .launchpad_details_table_sec {\n        margin-top: 40px;\n    }\n\n    .project_details_tab_sec {\n        margin: 40px 0px 0px;\n    }\n\n    .detail_right_col {\n        width: 100%;\n        margin-top: 0px;\n    }\n\n    .launchpad_modal_overlay {\n        align-items: end;\n    }\n\n}\n\n@media (max-width: 660px) {\n\n    .launchpad_cnt_block {\n        text-align: center;\n        flex-direction: column;\n    }\n\n    .launchpad_details_table_sec h3,\n    .project_details_tab_sec h3 {\n        font-size: 20px;\n    }\n\n    .pool_card {\n        padding: 20px;\n    }\n\n    .detail_content_layout .timeline_item {\n        flex-direction: row;\n        gap: 12px;\n    }\n\n    .detail_content_layout .timeline_item h4 {\n        margin-top: 0px;\n    }\n\n    .launchpad_cnt_block ul {\n        margin: 20px 0px 15px;\n        justify-content: center;\n    }\n\n    .launchpad_cnt_block ul li {\n        font-size: 19px;\n        line-height: 20px;\n    }\n\n    .about_Launchpad_btn {\n        justify-content: center;\n    }\n\n    .about_Launchpad_btn button.notification_btn {\n        padding: 0px;\n    }\n\n    .past_projects_title {\n        font-size: 22px;\n    }\n\n    .launchpad_past_projects_sec {\n        padding-bottom: 30px;\n        margin-top: 30px !important;\n    }\n\n    .pool_title h4 {\n        font-size: 15px;\n    }\n\n    .project_name_badge h3 {\n        font-size: 16px;\n    }\n\n    .project_icon {\n        width: 32px;\n        height: 32px;\n    }\n\n    .launchpad_wrapper_main {\n        padding: 40px 0;\n    }\n\n    .timeline {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 18px;\n    }\n\n    .timeline_item {\n        flex-direction: row;\n        align-items: center;\n        gap: 20px;\n    }\n\n    .timeline_item .marker {\n        margin-bottom: 0;\n    }\n\n    .timeline_line {\n        display: none;\n    }\n\n    .project_details_container {\n        flex-direction: column;\n        min-height: 250px;\n    }\n\n    .detail_header_row {\n        margin: 0px 0px 20px;\n    }\n\n    .breadcrumb {\n        margin-bottom: 0px;\n        font-size: 14px;\n    }\n\n    .sidebar_menu {\n        width: 100%;\n        border-right: none;\n        border-bottom: 1px solid #EAECEF;\n        display: flex;\n        overflow-x: auto;\n        padding: 0;\n    }\n\n    .menu_item {\n        white-space: nowrap;\n        padding: 16px;\n    }\n\n    .menu_item.active::before {\n        left: 16px;\n        right: 16px;\n        bottom: 0;\n        top: auto;\n        height: 3px;\n        width: auto;\n        border-radius: 4px 4px 0 0;\n    }\n\n    .table_row {\n        flex-direction: column;\n    }\n\n    .table_col_left {\n        padding: 16px 20px 2px;\n        border-bottom: none;\n    }\n\n    .table_col_right {\n        padding: 4px 20px 16px;\n    }\n\n    body .header_actions {\n        gap: 12px;\n    }\n\n    .launchpad_wrapper_main .detail_header_row .action_btn {\n        font-size: 12px;\n    }\n\n    .trade_btn_dark {\n        padding: 8px 24px;\n        font-size: 12px;\n    }\n\n    .detail_content_layout {\n        gap: 20px;\n    }\n\n    .projects_tab {\n        font-size: 16px;\n    }\n\n    .launchpad_projects_tabs {\n        gap: 20px;\n        margin-bottom: 22px;\n    }\n\n}\n\n/* Trade Form Specific Styles */\n.launchpad-trade-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.launchpad-trade-row.mt-16 {\n    margin-bottom: 0;\n    margin-top: 16px;\n}\n\n.launchpad-trade-row.mb-12 {\n    margin-bottom: 12px;\n}\n\n.launchpad-trade-label {\n    display: block;\n    margin-bottom: 8px;\n    color: #848e9c;\n    font-size: 14px;\n}\n\n.launchpad-trade-input {\n    width: 100%;\n    padding: 12px 14px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    outline: none;\n    font-size: 15px;\n    background-color: rgba(255, 255, 255, 0.05);\n    color: #fff;\n}\n\n.launchpad-trade-input::placeholder {\n    color: #848e9c;\n}\n\nbody.light_theme .launchpad-trade-input {\n    border: 1px solid #EAECEF;\n    background-color: #fff;\n    color: #1e2329;\n}\n\n.launchpad-trade-error {\n    color: #dc3545;\n    font-size: 13px;\n    margin: 8px 0 0;\n}\n\n.launchpad-trade-btn {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
